import React, { ReactElement } from 'react';
import {
  Button, LoaderButton, Table, Tbody, Td, Tr,
} from 'idsk-react-components';
import './subjektBezPripomienokListTable.scss';
import { useParams } from 'react-router';
import { ConfirmModal, Pagination } from 'slovlex-idsk-react-components';
import SubjektBezPripomienokListPage
  from '../../../../model/subjektbezpripomienok/SubjektBezPripomienokListPage';
import Secured from '../../../Secured';
import UserRole from '../../../../model/currentuser/UserRole';
import { useClient } from '../../../../context/ClientStatusContext';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import uuid from '../../../../model/Uuid';
import { removeSubjektBezPripomienok } from '../../../../client/subjektBezPripomienokClient';
import { useUserContext } from '../../../../context/UserContext';

interface Props {
  subjektPage: SubjektBezPripomienokListPage;

  reloadSubjektBezPripomienokList(): void;

  pageNumberFromUrl: number;
}

const SubjektBezPripomienokListTable = ({
  subjektPage,
  reloadSubjektBezPripomienokList,
  pageNumberFromUrl,
}: Props): ReactElement => {
  const {
    wrapClient: removeSubjektBezPripomienokClient,
  } = useClient(removeSubjektBezPripomienok);
  const { displaySuccess } = useSuccessMessageContext();
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const { fetchProfile } = useUserContext();

  const handleClick = async (subjektUuid: uuid): Promise<void> => {
    await removeSubjektBezPripomienokClient(type, year, index, subjektUuid);
    reloadSubjektBezPripomienokList();
    fetchProfile(type, year, index);
    displaySuccess('Odstránenie subjektu zo zoznamu "bez pripomienok" bolo úspešné.');
  };

  if (!subjektPage) {
    return null;
  }

  if (subjektPage.totalElements === 0) {
    return (
      <p className="text-center">Pre tento materiál neexistuje žiadny subjekt bez pripomienok.</p>
    );
  }

  if (subjektPage.totalElements > 0 && subjektPage.subjekty.length === 0) {
    return (
      <>
        <p className="text-center">
          Na aktuálnej stránke sa nenachádzajú žiadne subjekty bez pripomienok.
        </p>
        <Pagination
          number={pageNumberFromUrl}
          size={subjektPage.size}
          totalElements={subjektPage.totalElements}
          pageQueryName="pageSubj"
        />
      </>
    );
  }

  return (
    <div className="subjekt-bez-pripomienok-list-table">
      <Table>
        <Tbody>
          {subjektPage.subjekty.map((subjekt) => (
            <Tr key={subjekt.uuid}>
              <Td className="subjekt-bez-pripomienok-list-table-first-col">{subjekt.kratkeMeno}</Td>
              <Td>{subjekt.popis}</Td>
              <Td className="subjekt-button-column">
                <Secured
                  allowForRoles={[UserRole.SUPERADMIN]}
                >
                  <ConfirmModal
                    question="Naozaj si želáte odstrániť danú organizáciu zo zoznamu 'bez pripomienok'?"
                    cancelButtonText="Nie"
                    confirmButton={(<Button buttonStyle="action" size="large">Áno</Button>)}
                    openButton={(
                      <LoaderButton
                        className="remove-subjekt-button"
                        type="button"
                        buttonStyle="negative"
                        size="large"
                      >Odstrániť
                      </LoaderButton>
                    )}
                    doAfterConfirm={() => handleClick(subjekt.uuid)}
                  />
                </Secured>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Pagination
        number={pageNumberFromUrl}
        size={subjektPage.size}
        totalElements={subjektPage.totalElements}
        pageQueryName="pageSubj"
      />
    </div>
  );
};

export default SubjektBezPripomienokListTable;
